import React from 'react';
export function StatsStrip() {
  return <div className="bg-cf-gold text-black py-6 border-y-4 border-black" data-id="element-341">
      <div className="max-w-6xl mx-auto px-4 flex flex-wrap justify-center md:justify-between items-center gap-6 font-bebas text-2xl md:text-3xl tracking-wide" data-id="element-342">
        <div className="flex items-center gap-2" data-id="element-343">
          <span data-id="element-344">+500 INSTRUCTORES CONFÍAN</span>
        </div>
        <div className="hidden md:block w-2 h-2 bg-black rounded-full" data-id="element-345" />
        <div className="flex items-center gap-2" data-id="element-346">
          <span data-id="element-347">6+6 TOMOS + BONOS</span>
        </div>
        <div className="hidden md:block w-2 h-2 bg-black rounded-full" data-id="element-348" />
        <div className="flex items-center gap-2" data-id="element-349">
          <span data-id="element-350">4.9/5 CALIFICACIÓN</span>
        </div>
        <div className="hidden md:block w-2 h-2 bg-black rounded-full" data-id="element-351" />
        <div className="flex items-center gap-2" data-id="element-352">
          <span data-id="element-353">🇦🇷 TODO EL PAÍS</span>
        </div>
      </div>
    </div>;
}